import { render, staticRenderFns } from "./FirstUserLogin.vue?vue&type=template&id=b1dc4ed2&scoped=true&"
import script from "./FirstUserLogin.vue?vue&type=script&lang=js&"
export * from "./FirstUserLogin.vue?vue&type=script&lang=js&"
import style0 from "./FirstUserLogin.vue?vue&type=style&index=0&id=b1dc4ed2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dc4ed2",
  null
  
)

export default component.exports